const scrollTopSmoothly = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export default scrollTopSmoothly;
